import { render, staticRenderFns } from "./passenger-modal-factory.vue?vue&type=template&id=879aa660&scoped=true"
import script from "./passenger-modal-factory.vue?vue&type=script&lang=js"
export * from "./passenger-modal-factory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879aa660",
  null
  
)

export default component.exports